import { ELIGIBILITY_DISCOUNTS, FOSTER_CITY_ZIP } from '../../utils/eligibilityDiscounts';

/**
 * Marks a parent with ZIP 94404 on file, or a student with such a parent: who
 * `create_invoice_on_enrollment()` gives the Foster City Resident discount on a Kaleido program.
 * Derived from the ZIP every render, so it is never out of step with billing.
 */
export function FosterCityResidentBadge({ className = '' }: { className?: string }) {
  return (
    <span
      title={`ZIP ${FOSTER_CITY_ZIP} on file: gets the Foster City Resident discount on Kaleido programs`}
      className={`inline-flex items-center rounded-full bg-teal-50 px-2 py-0.5 text-xs font-medium text-teal-700 whitespace-nowrap ${className}`}
    >
      {ELIGIBILITY_DISCOUNTS.foster_city_resident.holderLabel}
    </span>
  );
}
